const CheckSvg = ({ fill = 'none', stroke = '#696969', strokeWidth = 2 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill={fill}
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M20 6 9 17l-5-5"
    />
  </svg>
);

export default CheckSvg;
